import React from 'react';
import { TimerResetIcon, MessageSquareIcon, SlidersHorizontalIcon } from 'lucide-react';
import { Section } from './Shared';
import { benefits } from '../data/pack';
const icons = [TimerResetIcon, MessageSquareIcon, SlidersHorizontalIcon];
export const Benefits = () => <Section className="max-w-5xl py-10 md:py-16" data-id="element-18" data-mp="4i30y03wcbha">
    <div className="grid grid-cols-1 gap-5 md:grid-cols-3" data-id="element-19" data-mp="3vpp5duyfwhz7">
      {benefits.map((benefit, i) => {
      const Icon = icons[i];
      return <article key={benefit.title} className="paper-panel flex h-full flex-col rounded-2xl p-6 md:p-7" data-id="element-20" data-mp="3mq255chg5i7q" data-mpi={i}>
            <Icon className="h-7 w-7 text-brand-goldDark" strokeWidth={1.4} aria-hidden="true" data-id="element-21" data-mp="3hs0kwo8abcuo" />
            <h3 className="mt-4 font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-burgundy md:text-base" data-id="element-22" data-mp="3cu7im6a3r2zo">
              {benefit.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-brand-text md:text-[15px]" data-id="element-23" data-mp="1b1axfqmhak1u">
              {benefit.text}
            </p>
          </article>;
    })}
    </div>
  </Section>;